import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ideabehind() {
  return (
    <section className="idea_behind p-100 text_color">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="idea_img">
              <StaticImage
                src="../../../images/case-studies/moodbe/concept.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={626}
                height={843}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h1>
              The Concept
              <span style={{ color: "#5A67FF" }}> Behind MoodBe</span>
            </h1>
            <p>
              We believe that emotions truly matter when it comes to building
              meaningful and lasting relationships. That’s what our client
              wanted us to emphasize when designing MoodBe. From feeling
              adventurous to seeking comfort, the app lets you express your mood
              and receive compatible matches instantly. So, whether you're
              looking for a casual date or a long-term partner, MoodBe is the
              app for you.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ideabehind;
